import styled from 'styled-components';

interface IGridCheckboxFilterProps {}

// styled-components v6: explicit type parameter required for attrs-injected custom props
interface CheckboxContainerAttrs {
  activeColor?: string;
  checkboxColorDisabled?: string;
  checkboxColorActive?: string;
  checkboxBorderColor?: string;
  checkboxBackgroundColorDisabled?: string;
}

export const GridCheckboxFilterContainer = styled.div<IGridCheckboxFilterProps>`
  display: flex;
  flex-direction: column;
  margin-top:1.25rem;
  align-content: flex-start
  font-family: "Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif;
  font-size:  0.75rem; 
  color: ${({theme}) => theme.text.onSurface.strong};
`;

export const GridCheckboxFilterMainOuterContainer = styled(
  GridCheckboxFilterContainer
)`
  max-height: 15rem;
  overflow-y: auto;
  border: 2px solid ${({theme}) => theme.border.medium};
  margin-top: 0.5rem;
  padding: 0.25rem 0.25rem 0.25rem 0.25rem;
  background: ${(prop)=>prop.theme.background.surface};
  border-radius: 4px;
  font-size: 0.75rem;
  &.text.label {
    font-family: "Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif;
    font-size: 0.75rem;
    background: black;
  }
  label.shell-checkbox-wrapper {
    padding-left: 0.75rem !important;
    margin-bottom: 0.5rem !important;
  }

  hr.solid {
    border: 0.5px solid #383C41;
    border-radius: 4px;
    width: 12rem;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #363537;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #d9d9d9;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const GridCheckboxFilterMainContainer = styled(
  GridCheckboxFilterContainer
)`
  background: ${(prop)=>prop.theme.background.surface};
  border-radius: 4px;
  margin-top: 0;
  font-size: 0.75rem;
  &.text.label {
    font-family: "Avenir Next", Tahoma, Helvetica, Arial, Roboto, sans-serif;
    font-size: 0.75rem;
  }
  label.shell-checkbox-wrapper {
    padding-left: 0.75rem !important;
  }
  ::-webkit-scrollbar {
    width: 5px;
  }
`;

const checkboxBorderColorDisabled = 'grey';

export const CheckboxContainer = styled.label.attrs<CheckboxContainerAttrs>(({theme}) => ({
  activeColor: '#313439',
  checkboxColorDisabled: 'grey',
  checkboxColorActive: '#D9D9D9',
  checkboxBorderColor: '#383C41',
  checkboxBackgroundColorDisabled: '#313439',
}))`
  &.shell-checkbox-wrapper {
    display: inline-flex;
    cursor: pointer;
    height: 24px;

    .shell-checkbox + span {
      margin-left: 12px;
      vertical-align: top;
      line-height: 24px;
      > span.key {
        display: block;
        float: right;
      }
      &.percentage {
        line-height: 12px;
      }
    }

    .shell-checkbox {
      white-space: nowrap;
      outline: none;
      display: inline-block;
      position: relative;
      vertical-align: top;
      height: 24px;

      &.shell-checkbox-input:focus + .shell-checkbox-inner {
        border-color: ${(props) => props.activeColor};
      }

      .shell-checkbox-input {
        position: absolute;
        left: 0;
        z-index: 9999;
        cursor: pointer;
        opacity: 0;
        top: 0;
        bottom: 0;
        right: 0;
      }

      .shell-checkbox-inner {
        position: relative;
        top: 0;
        left: 0;
        display: inline-block;
        width: 24px;
        height: 24px;
        border-width: 1px;
        border-style: solid;
        border-radius: 4px;
        border-color: ${(props) => props.checkboxBorderColor};
        background-color: #111417;
        transition: border-color 200ms ease-out;

        &:after {
          transform: rotate(40deg);
          position: absolute;
          left: 7px;
          top: 2px;
          display: table;
          width: 7px;
          height: 15px;
          border: 2px solid ${(props) => props.checkboxColorActive};
          border-top: 0;
          border-left: 0;
          content: ' ';
          opacity: 0;
          transition: opacity 200ms ease-out;
        }
      }
    }

    &:hover .shell-checkbox .shell-checkbox-inner {
      border-color: ${(props) => props.activeColor};
    }

    .shell-checkbox-checked .shell-checkbox-inner {
      background-color: ${(props) => props.activeColor};
      border-color: ${(props) => props.activeColor};

      &:after {
        opacity: 1;
      }
    }

    &.shell-checkbox-wrapper-small {
      margin-right: 12px;

      .shell-checkbox {
        margin-top: 4px;
        height: 16px;

        .shell-checkbox-inner {
          width: 16px;
          height: 16px;

          &:after {
            transform: rotate(40deg);
            position: absolute;
            left: 4px;
            top: 1px;
            width: 5px;
            height: 10px;
            border: 2px solid ${(props) => props.checkboxColorActive};
            border-top: 0;
            border-left: 0;
          }
        }
      }

      &.shell-checkbox-wrapper-indeterminate {
        .shell-checkbox .shell-checkbox-inner {
          &:after {
            opacity: 1;
            transform: none;
            position: absolute;
            left: 3px;
            top: 6px;
            width: 8px;
            height: 2px;
            background-color: ${(props) => props.activeColor};
            border: none;
          }
        }
      }
    }

    &.shell-checkbox-wrapper-indeterminate {
      .shell-checkbox-checked .shell-checkbox-inner:after,
      .shell-checkbox-inner:after {
        opacity: 1;
        transform: none;
        background-color: ${(props) => props.activeColor};
        border: none;
        top: 10px;
        left: 6px;
        width: 10px;
        height: 2px;
      }

      .shell-checkbox-disabled {
        &.shell-checkbox-checked .shell-checkbox-inner,
        .shell-checkbox-inner:after {
          background-color: ${checkboxBorderColorDisabled};
        }
      }
    }

    &.shell-checkbox-wrapper-disabled {
      cursor: default;

      .shell-checkbox + span {
        color: ${(props) => props.checkboxColorDisabled};
      }

      .shell-checkbox-disabled {
        &.shell-checkbox-checked .shell-checkbox-inner,
        .shell-checkbox-inner {
          background-color: ${(props) => props.checkboxBackgroundColorDisabled};
          border-color: ${checkboxBorderColorDisabled};

          &:after {
            border-color: ${(props) => props.checkboxColorDisabled};
          }
        }
      }

      .shell-checkbox-input {
        cursor: default;
      }
    }
  }
`;
